<template>
<div style="text-align:center">
    <div v-if="type == 'front'">
        <div
            v-for="motorbike in motorbike_front"
            :key="motorbike._id"
            class="bike-card"
            style="text-align:left"
        >
            <div class="bike-card-info" style="margin-top: 0.25cm">Số phòng:
                <span style="margin-left: 2.75cm">
                    <strong style="font-size: 22px">{{ motorbike.room_id }}</strong>
                </span>
            </div>
            <div class="bike-card-info">Ngày in:
                <span style="margin-left: 2.75cm">{{ date | formatTimeVN }}</span>
            </div>
            <div class="bike-card-info">Họ tên:
                <span style="margin-left: 2.25cm">{{ motorbike.customer_name}}</span>
            </div>
            <h2 class="text-center" style="font-size: 45px; margin-bottom: 0; margin-top: 20px">
                {{ motorbike.name }}
            </h2>
        </div>
        <div style="break-after: page"></div>
    </div>

    <div v-if="type == 'back'">
        <div
            v-for="motorbike in motorbike_back"
            :key="motorbike._id + '_back'"
            class="bike-card"
            style="text-align:left"
        >
            <div style="display: flex">
                <img style="margin-top: 0.25cm" src="https://i.imgur.com/YUiTfmS.png" alt="bike-ticket-logo" width="150" height="50">
                <h1 style="display: inline-block">{{ motorbike.building_text.toUpperCase() }}</h1>
            </div>
            <h2 class="text-center" style="font-size: 45px; margin-top: 7px;">
                THẺ GIỮ XE
            </h2>
        </div>
        <div style="break-after: page"></div>
    </div>

    <div v-if="type == 'addition' || type == 'room_id' || type == 'motorbike_name'">
        <h2 class="text-center" style="margin-bottom: 0;">
            {{ title }}
        </h2>
        <h3 style="margin-top: 10px;">NGÀY {{ date | formatTimeVN }} </h3>
        <table style="width: 100%" class="mx-auto table-border">
            <thead>
                <th>STT</th>
                <th>SỐ PHÒNG</th>
                <th>TÊN THÀNH VIÊN</th>
                <th>BIỂN SỐ XE</th>
                <th>GHI CHÚ</th>
            </thead>
            <tbody>
                <tr
                    v-for="(motorbike, index) in items"
                    :key="motorbike._id"
                >
                    <td>{{ index + 1 }}</td>
                    <td style="width: 100px">{{ motorbike.room_id }}</td>
                    <td class="text-left">{{ motorbike.customer_name }}</td>
                    <td>{{ motorbike.name }}</td>
                    <td class="text-left">{{ motorbike.note }}</td>
                </tr>
            </tbody>
        </table>
        <div v-if="type == 'addition'">
            <h4 class="text-left">TỔNG SỐ THẺ XE BS {{ building_text !== "TẤT CẢ" ? "TÒA NHÀ " + building_text : "TẤT CẢ TÒA NHÀ"}} : {{items.length}} thẻ x .... bộ ( .... bộ ..........)</h4>
            <div style="width: 50%; display: inline-block">
                <h4>Người lập</h4>
            </div>
            <div style="width: 50%; display: inline-block">
                <h4>Bảo vệ ký nhận</h4>
            </div>
        </div>
    </div>
</div>
</template>

<script>

export default {
    name: "print-the-xe",
    props: {
        items: Array,
        type: String,
        title: String,
        building_text: String
    },
    computed: {
        motorbike_front (){
            return this.items;
        },
        motorbike_back (){
            const arr = [];
            this.items.forEach((item, index) => {
                if (index % 2 == 0)
                    if (index + 1 < this.items.length)
                        arr[index + 1] = item;
                    else arr[index] = item;
                else {
                    arr[index - 1] = item;
                };
            })
            return arr;
        },
        date(){
            return new Date().toISOString().substring(0, 10)
        },
        // combine_list (){
        //     const arr = [];
        //     let arr_i = 0;

        //     for (let i = 0; i < this.items.length; i++){
        //         const item = this.items[i];
        //         // [[ mặt trước], [mặt sau], [ mặt trước], [mặt sau], [ mặt trước], [mặt sau], [ mặt trước], [mặt sau]]
        //         // Mặt trước:
        //         if (!arr[arr_i])
        //             arr[arr_i] = [item];
        //         else arr[arr_i].push(item);

        //         // mặt sau: [1, 0, 3, 2, 5, 4, 7, 6] -> phức tạp vãi =))
        //         if (!arr[arr_i + 1]){
        //             const temp = []
        //             this.handleBackArray(item, i, temp);
        //             arr[arr_i + 1] = temp;
        //         } else this.handleBackArray(item, i, arr[arr_i + 1]);

        //         if ((i + 1) % 10 == 0)
        //             arr_i += 2;
        //     }
        //     return arr;
        // }
    },
    data(){
        return {
        }
    },
    methods: {
        handleBackArray(item, item_index, arr){
            let new_index = item_index % 10
            if (new_index % 2 == 0)
                if (item_index + 1 < this.items.length)
                    arr[new_index + 1] = item;
                else arr[new_index] = item;
            else {
                arr[new_index - 1] = item;
            };
        }
    }
};
</script>